"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  description: '<p><code style="font-family: monospace; word-wrap: break-word">Testing colors&nbsp;</code></p> <p><br></p> <blockquote>quote lorem ipsum</blockquote> <p><a href="https://www.google.com">here</a></p> <p><br></p> <p><em style="font-style: italic">italic</em></p> <p><br></p> <p><strong style="font-weight: bold">bold</strong></p> <p><br></p> <p><u style="text-decoration: underline">underline</u></p> <p><br></p> <ul> <li><u style="text-decoration: underline">1</u></li> <li><u style="text-decoration: underline">2</u></li> <li><u style="text-decoration: underline">3</u></li> </ul> <ol> <li><u style="text-decoration: underline">3</u></li> <li><u style="text-decoration: underline">2</u></li> </ol> <p><br></p>',
  id: 203,
  updatedAt: '2021-06-08T22:31:01.000000Z',
  completed: true,
  title: 'Secretaria',
  division: '',
  type: 'Event',
  zipCode: '',
  status: 'inactive',
  city: '',
  cityName: '',
  state: '',
  stateName: '',
  logoUrl: 'https://hive-development-files.s3.amazonaws.com/company_92_logo_1615220728.blob',
  photoUrl: 'https://hive-development-files.s3.amazonaws.com/company_92_photo_1620941733.blob',
  teamMedia: '',
  teamMediaDescription: '',
  teamMediaCaption: '',
  activation: '',
  activationDay: '',
  activationMonth: '',
  activationYear: '',
  deadline: '',
  deadlineDay: '',
  deadlineMonth: '',
  deadlineYear: '',
  start: '2021-04-09T22:31:01.000000Z',
  startDay: 9,
  startMonth: 4,
  startYear: 2021,
  expectedDateDay: 9,
  expectedDateMonth: 4,
  expectedDateYear: 2021,
  end: '2022-01-21T22:31:01.000000Z',
  endDay: 21,
  endMonth: 4,
  endYear: 2026,
  temporaryEnd: '',
  temporaryEndDay: '',
  temporaryEndMonth: '',
  temporaryEndYear: '',
  numberOfPotentialHires: '10',
  otherQualifications: '',
  applicantExtra: [],
  summary: 'short short short',
  tips: '',
  satScore: '',
  actScore: '',
  seeking: null,
  requirements: '',
  additionalLinks: [],
  experience: '',
  caption: '',
  duration: '',
  salary: '',
  hourForWeek: '',
  employmentStart: '',
  employmentStartDay: '',
  employmentStartMonth: '',
  employmentStartYear: '',
  employmentEnd: '',
  employmentEndDay: '',
  employmentEndMonth: '',
  employmentEndYear: '',
  compensationType: '',
  compensationSubType: '',
  compensationAmount: '',
  laborActAgreement: false,
  benefits: '',
  detailed: '',
  minGpa: '',
  maxGpa: '',
  createdAt: '2021-04-09T16:31:43.000000Z',
  graduationMonth: '',
  graduationYear: '',
  deliveryPreferences: [],
  applicationUrl: 'https://ole.com.ar',
  paymentPeriod: '',
  industries: [{
    industryId: 3,
    subIndustryId: 300,
    industry: {
      id: 3,
      name: 'Architecture & Construction',
      created_at: null,
      updated_at: null,
      parent_id: null
    },
    subIndustry: {
      id: 300,
      name: 'Building Materials',
      created_at: null,
      updated_at: null,
      parent_id: 3
    }
  }],
  jobFunctions: [{
    id: 3,
    name: 'Advertising & Marketing'
  }],
  majors: [],
  minors: [],
  languages: [],
  degrees: [],
  majorCategories: [{
    id: 1,
    name: 'Creative Arts, Performing Arts & Design'
  }],
  minorCategories: [],
  contactFields: [],
  recipients: [],
  coworkers: [],
  studentTypes: [],
  firstName: '',
  lastName: '',
  email: '',
  locations: [{
    id: 263,
    stateCode: 'AR',
    state: {
      name: 'Arkansas',
      state_code: 'AR'
    },
    city: {
      id: 304,
      city: 'Alexander',
      state_code: 'AR'
    },
    cityId: 304,
    cityName: '',
    country: null,
    countryId: null,
    countryName: '',
    international: false,
    zipCode: '1684',
    type: 2
  }, {
    id: 486,
    stateCode: 'AR',
    state: {
      name: 'Arkansas',
      state_code: 'AR'
    },
    city: {
      id: 304,
      city: 'Alexander',
      state_code: 'AR'
    },
    cityId: 304,
    cityName: '',
    country: null,
    countryId: null,
    countryName: '',
    international: false,
    zipCode: null,
    type: 1
  }, {
    id: 487,
    stateCode: '',
    state: null,
    city: null,
    cityId: null,
    cityName: 'test',
    country: {
      id: 8,
      country: 'Azerbaijan',
      created_at: null,
      updated_at: null
    },
    countryId: 8,
    countryName: '',
    international: true,
    zipCode: null,
    type: 3
  }],
  company: {
    id: 92,
    name: 'Apple',
    email: 'glofrano@gmail.com'
  },
  profilePictures: false,
  diversities: false,
  sponsorshipVisaRequirements: null,
  name: '',
  whyOurCompany: false,
  whyQualified: ['Languages not match', 'Major categories not match', 'GPA not match', 'Class standing not match'],
  moreInfoUrl: '',
  hasExternalApplicationLink: null,
  computer: '',
  partTimeDuration: '',
  contactTitle: '',
  contactDivision: '',
  contactCompany: '',
  contactState: '',
  coworkersVideoUrl: '',
  atsSystemId: 4,
  atsSystem: null,
  applicationsReceived: [2],
  expectedDateHire: '',
  applicantsFilter: 2,
  compensation: null,
  compensationPeriod: null,
  industryId: null,
  subIndustryId: null,
  requireUsWorkAuthorization: false,
  sponsorWorkVisa: false,
  opportunityFor: 1,
  opportunityForName: null,
  opportunityForDescription: null,
  hiringTemporarilyAuthorizedCandidates: false,
  teamMediaImageName: null,
  teamMediaVideoName: null,
  eventRegistrationUrl: 'http://www.EventRegistration.com',
  buzzwords: true,
  classStanding: [1, 2, 3, 4, 5],
  anteMeridiem: false,
  startHour: 8,
  lateYear: null,
  lateMonth: null,
  earlyYear: null,
  earlyMonth: null,
  hasTranscript: false,
  hasPortfolio: false,
  visibleForCandidates: null,
  preferredContactEmail: 'preferredemail@gmail.com',
  annualSalaryFrom: null,
  annualSalaryTo: null,
  resumeRequired: false,
  endHour: 3,
  endHourAnteMeridiem: true,
  compensationVisibleForStudents: null,
  eventAnteMeridiem: false,
  eventDay: 2,
  eventMonth: 2,
  eventYear: 2023,
  eventHour: 3,
  reviewApplications: null,
  isCopy: false,
  totalApplicants: 3,
  newApplicants: [],
  totalNewApplicants: 0,
  applicants: [{
    id: 178,
    opportunityId: 203,
    student: {
      id: 1,
      image: '',
      firstName: 'Elizabet',
      lastName: 'Britez',
      photoUrl: '',
      cityOfHomeName: 'La Reja',
      stateOfHomeName: 'Wisconsin',
      typeId: '3',
      typeName: 'Junior',
      universityName: 'Benedictine University',
      myselfEmoji: '❤️❤️❤️❤️❤️',
      firstMajorName: '',
      firstMajorConcentration: '',
      stateOfHome: 'WI',
      cityOfUniversityName: 'Excel',
      stateOfUniversity: 'AL',
      gpa: '3.7',
      yearGraduation: '2030',
      monthGraduation: '2',
      firstMajorYear: '2011',
      includeGPAOnResume: true,
      specialization: '1',
      internationalHome: 1,
      countryOfHomeName: 'Azerbaijan',
      firstMajorSecondConcentration: '',
      firstMajorMonth: 2,
      secondMajorName: '',
      secondMajorConcentration: '',
      secondMajorSecondConcentration: '',
      thirdMajorName: '',
      thirdMajorConcentration: '',
      thirdMajorSecondConcentration: '',
      otherFirstMajor: 'Other major',
      otherSecondMajor: '',
      otherThirdMajor: '',
      diversity: [],
      includeDiversityInclusionsResume: true
    },
    resumeUrl: 'https://api-dev-employer.hellohive.com/v1/employer/applicants/178/resume',
    applyDate: '2021-04-12T11:34:27.000000Z',
    coverLetter: null,
    transcript: '',
    portfolioUrl: '',
    transcriptShort: null,
    portfolioUrlShort: null,
    tag: 'no-way',
    status: null,
    externalLinkSended: false,
    whyOurCompanyReason: '',
    contactTag: 5,
    isAgree: null
  }, {
    id: 198,
    opportunityId: 203,
    student: {
      id: 456,
      image: '',
      firstName: 'Meredith',
      lastName: 'Grey',
      photoUrl: 'https://hive-development-files.s3.amazonaws.com/user-profile-pic-1618193378.blob',
      cityOfHomeName: 'Alpine',
      stateOfHomeName: 'Arizona',
      typeId: '2',
      typeName: 'Sophomore',
      universityName: 'Abraham Baldwin Agricultural College',
      myselfEmoji: '😍😘🤨😑🤑',
      firstMajorName: 'Actuarial Science',
      firstMajorConcentration: '',
      stateOfHome: 'AZ',
      cityOfUniversityName: 'Alpine',
      stateOfUniversity: 'AZ',
      gpa: '3.0',
      yearGraduation: '2012',
      monthGraduation: '5',
      firstMajorYear: '2012',
      includeGPAOnResume: true,
      specialization: '1',
      internationalHome: 0,
      countryOfHomeName: '',
      firstMajorSecondConcentration: '',
      firstMajorMonth: 5,
      secondMajorName: '',
      secondMajorConcentration: '',
      secondMajorSecondConcentration: '',
      thirdMajorName: '',
      thirdMajorConcentration: '',
      thirdMajorSecondConcentration: '',
      otherFirstMajor: '',
      otherSecondMajor: '',
      otherThirdMajor: '',
      diversity: [],
      includeDiversityInclusionsResume: true
    },
    resumeUrl: 'https://api-dev-employer.hellohive.com/v1/employer/applicants/198/resume',
    applyDate: '2021-04-20T12:54:03.000000Z',
    coverLetter: null,
    transcript: 'http://www.google.com/transcript',
    portfolioUrl: 'http://www.google.com/portfolio',
    transcriptShort: 'heyhive.co/599',
    portfolioUrlShort: 'heyhive.co/vyl',
    tag: null,
    status: null,
    externalLinkSended: true,
    whyOurCompanyReason: '',
    contactTag: 3,
    isAgree: null
  }, {
    id: 224,
    opportunityId: 203,
    student: {
      id: 491,
      image: '',
      firstName: 'fer',
      lastName: 'fer',
      photoUrl: '',
      cityOfHomeName: 'Adona',
      stateOfHomeName: 'Arkansas',
      typeId: '3',
      typeName: 'Junior',
      universityName: 'Abilene Christian University',
      myselfEmoji: '😆😂😂😂😂',
      firstMajorName: 'Advertising',
      firstMajorConcentration: '',
      stateOfHome: 'AR',
      cityOfUniversityName: 'Akiachak',
      stateOfUniversity: 'AK',
      gpa: '3',
      yearGraduation: '2012',
      monthGraduation: '3',
      firstMajorYear: '2013',
      includeGPAOnResume: true,
      specialization: '1',
      internationalHome: 0,
      countryOfHomeName: '',
      firstMajorSecondConcentration: '',
      firstMajorMonth: 3,
      secondMajorName: '',
      secondMajorConcentration: '',
      secondMajorSecondConcentration: '',
      thirdMajorName: '',
      thirdMajorConcentration: '',
      thirdMajorSecondConcentration: '',
      otherFirstMajor: '',
      otherSecondMajor: '',
      otherThirdMajor: '',
      diversity: [],
      includeDiversityInclusionsResume: false
    },
    resumeUrl: 'https://api-dev-employer.hellohive.com/v1/employer/applicants/224/resume',
    applyDate: '2021-04-21T10:23:57.000000Z',
    coverLetter: null,
    transcript: '',
    portfolioUrl: 'https://www.linkedin.com/in/fernando-romero-1bb3a0198/detail/contact-info/',
    transcriptShort: null,
    portfolioUrlShort: 'heyhive.co/maf',
    tag: null,
    status: null,
    externalLinkSended: true,
    whyOurCompanyReason: '',
    contactTag: 3,
    isAgree: null
  }],
  createdBy: {
    id: 175,
    username: 'silveyraflor+apple@gmail.com',
    name: 'Florencia',
    email: 'silveyraflor+apple@gmail.com'
  },
  createdByUserLogged: true
};
exports.default = _default;